import { render, staticRenderFns } from "./returnDetail.vue?vue&type=template&id=665b2456&scoped=true&"
import script from "./returnDetail.vue?vue&type=script&lang=js&"
export * from "./returnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b2456",
  null
  
)

export default component.exports